'use es6';

import toJS from 'transmute/toJS';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import { useUserOptions } from '../../../data/hooks/useUserOptions';
import { useControlsContext } from '../context';
import { jsx as _jsx } from "react/jsx-runtime";
const MINIMUM_SEARCH_COUNT = 3;
const EmailRecipientSelect = () => {
  const {
    data: recipients
  } = useUserOptions();
  const {
    recipientSet,
    onChangeRecipientSet
  } = useControlsContext();
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailInternalRecipientSelectLabel"
    }),
    required: true,
    children: /*#__PURE__*/_jsx(UISelect, {
      anchorType: "button",
      "data-test-id": "email-report-recipients-select",
      options: toJS(recipients),
      onChange: onChangeRecipientSet,
      value: toJS(recipientSet),
      multi: true,
      minimumSearchCount: MINIMUM_SEARCH_COUNT,
      placeholder: ""
    })
  });
};
export default EmailRecipientSelect;